// extracted by mini-css-extract-plugin
export default {"modal":"modal-fW7jG7"};